import { Component, Input, SimpleChanges, OnChanges, OnInit } from '@angular/core';

import { HisAuthService, HisUiService } from 'hisng';

import { ProjectService } from 'app/fs/res/finance/service/project/project.service';

import { Project } from 'app/fs/res/finance/model/project/project';

@Component( {
    selector: 'res-priority-patent-view-projects',
    templateUrl: './priority-patent-view-projects.component.html',
} )
export class PriorityPatentViewProjectsComponent implements OnChanges, OnInit {
    @Input() projects: Project[];

    public dateFormat: string;

    constructor(
        public auth: HisAuthService,
        private hisUiService: HisUiService,
        private projectService: ProjectService
    ) { }

    /* Component ngOnInit */
    ngOnInit() {
        this.dateFormat = this.hisUiService.translate( 'common.dateFormat' );
    }

    /* Component ngOnChanges */
    ngOnChanges( changes: SimpleChanges ) {
        if ( changes ) {
            if ( this.projects ) {
                this.projects.forEach( p => {
                    this.projectService.getProjectById( p.id ).subscribe( (project: Project) => {
                        p.members = [...project.members];
                    } );
                } );
            }
        }
    }
}
